import * as R from 'ramda';
import * as yup from 'yup';


export const addRaterByEmailFormValidation = (
  invalidEmailMsg: string,
  nameRequiredMsg: string,
  requiresNameToAdd: boolean,
) => yup.object().shape(
  {
    firstName: requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                 .  string(),
    lastName:  requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                   .string(),
    email:     yup
                 .string()
                 .email(invalidEmailMsg)
                 .required(invalidEmailMsg),
    levelId:   yup
                 .number()
                 .positive()
                 .required(),
  },
);

export const editRaterWithNamesFormValidation = (
  invalidEmail: string,
  invalidLevelId: (levelId: number) => string,
  acceptableLevelIds?: number[],
) => yup.object().shape(
  {
    firstName:  yup
                  .string(),
    lastName:   yup
                  .string(),
    email:      yup
                  .string()
                  .email(invalidEmail),
    levelId:    acceptableLevelIds
                  ? yup
                      .number()
                      .test('is-valid-level-id',
                        (input) => invalidLevelId(input.value),
                        n => R.contains(n, acceptableLevelIds))
                  : yup
                      .number()
                      .positive(),
    languageId: yup
                  .number()
                  .positive(),
  },
);

export const editRaterFormValidation = (
  invalidEmail: string,
  invalidLevelId: (levelId: number) => string,
  acceptableLevelIds?: number[],
) => yup.object().shape(
  {
    email:      yup
                  .string()
                  .email(invalidEmail),
    levelId:    acceptableLevelIds
                  ? yup
                      .number()
                      .test('is-valid-level-id',
                        (input) => invalidLevelId(input.value),
                        n => R.contains(n, acceptableLevelIds))
                  : yup
                      .number()
                      .positive(),
    languageId: yup
                  .number()
                  .positive(),
  },
);


export const customizeMessageFormValidation = yup.object().shape(
  {
    customText: yup.string(),
  },
);

export const deliverReportFormValidation = (
  invalidEmailMsg: string,
  nameRequiredMsg: string,
  requiresNameToAdd: boolean,
) => yup.object().shape(
  {
    firstName: requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                 .  string(),
    lastName:  requiresNameToAdd
               ? yup
                   .string()
                   .required(nameRequiredMsg)
               : yup
                   .string(),
    email:     requiresNameToAdd
               ? yup
                 .string()
                 .email(invalidEmailMsg)
                 .required(invalidEmailMsg)
               : yup
                 .string(),
  },
);
